import { Component } from '@angular/core';

import { IMenuItemAngularComp } from 'ag-grid-angular';
import { IMenuConfigParams, IMenuItemParams } from 'ag-grid-community';

import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import { TextComponent } from '@camelot/ui';

import { CamTranslationGrid } from '../../../translation.service';

export interface CustomMenuItemParams extends IMenuItemParams {
  action: () => void;
  icon: string;
}

@Component({
  host: { 'data-cid': 'context-menu-item' },
  imports: [TranslatePipe, TextComponent, FontIconComponent],
  selector: '',
  styleUrl: './context-menu-item.component.scss',
  templateUrl: './context-menu-item.component.html',
})
export class ContextMenuItemComponent implements IMenuItemAngularComp {
  public params: CustomMenuItemParams | null = null;
  public hasSubMenu = false;

  constructor() {
    CamTranslationGrid.getInstance();
  }

  agInit(params: CustomMenuItemParams) {
    this.params = params;
    this.hasSubMenu = !!params.subMenu?.length;
  }

  configureDefaults(): IMenuConfigParams {
    return { suppressClick: true };
  }

  public onClick() {
    if (!this.params || this.params.disabled) {
      return;
    }
    if (this.hasSubMenu) {
      this.params.openSubMenu(true);
      return;
    }
    this.params.action?.();
    this.params.closeMenu();
  }

  public onMouseEnter() {
    if (this.hasSubMenu) {
      this.params?.openSubMenu(false);
    }
  }
}
